import React                  from 'react';
import { hot }                from 'react-hot-loader/root';
import { History }            from 'history';
import { compose }            from 'redux';
import { Provider }           from 'react-redux';
import {
  QueryClient,
  QueryClientProvider,
}                             from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Helmet }             from 'react-helmet';
import { PersistGate }        from 'redux-persist/integration/react';
import { ThemeProvider }      from 'styled-components';
import { ConnectedRouter }    from 'connected-react-router';
import { SnackbarProvider }   from 'notistack';
import {
  withWidth,
  CssBaseline,
}                             from '@material-ui/core';
import {
  ThemeProvider as MuiThemeProvider,
}                             from '@material-ui/styles';
import { Breakpoint }         from '@material-ui/core/styles/createBreakpoints';
import { Notification }       from '@components/Notification/Notification';
import {
  theme,
  muiTheme,
  BaseStyles,
}                             from './styles';
import { routes }             from './routes';

interface IAppComponentProps {
  store   : any;
  history : History;
  width   : Breakpoint;
}

const queryClient = new QueryClient();

const AppContainer = ({
  width,
  history,
  store: {
    persistor,
    createdStore,
  },
}: IAppComponentProps): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={{ ...theme, width }}>
      <MuiThemeProvider theme={muiTheme}>
        <Provider store={createdStore}>
          <PersistGate loading={null} persistor={persistor}>
            <SnackbarProvider>
              <Helmet titleTemplate="CUAuctions Management Intranet" defaultTitle="CUAuctions Management Intranet" />
              <BaseStyles />
              <CssBaseline />
              <ConnectedRouter history={history}>
                {routes}
              </ConnectedRouter>
              <Notification />
            </SnackbarProvider>
          </PersistGate>
        </Provider>
      </MuiThemeProvider>
    </ThemeProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

const App = compose(
  hot,
  withWidth(),
)(AppContainer);

export { App };
